<template>
  <div></div>
</template>
<script>
import { CSBase } from '@complispace/cs-design-system';

export default {
  name: 'TempPage',
  extends: CSBase,
  data() {
    const { moduleId, pagePath } = this.$route.params;
    this.$router.replace({
      name: 'Page',
      params: { moduleId, pagePath }
    });
    return {
      loading: false
    };
  }
};
</script>
